import { useMutation } from '@tanstack/react-query';
import { UpdateSubscriptionPlanPayload } from '../../types/subscriptions';
import { changeSubscriptionPlan } from '../../services/subscriptions';

interface Options {
  onSuccess?: (
    data: Awaited<ReturnType<typeof changeSubscriptionPlan>>,
  ) => void;
  onError?: (error: Error) => void;
  onMutate?: (args: UpdateSubscriptionPlanPayload) => void;
  onSettled?: () => void;
}

function useChangeSubscriptionPlan(subscriptionId: string, options?: Options) {
  return useMutation({
    mutationFn: async (payload: UpdateSubscriptionPlanPayload) => {
      if (!subscriptionId) throw new Error('Subscription ID is required');

      const result = await changeSubscriptionPlan({
        ...payload,
        subscriptionId,
      });

      return result;
    },
    onSuccess: options?.onSuccess,
    onError: options?.onError,
    onMutate: options?.onMutate,
    onSettled: options?.onSettled,
  });
}

export default useChangeSubscriptionPlan;
